import * as React from 'react';

/**
 * A root node branching into two field nodes: a schema as a structure of
 * metadata fields. Used for Asset Schemas, which shared `Stack` with
 * Collections and was indistinguishable from it two rows apart.
 */
function TreeStructure(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <rect x={3} y={12} width={8} height={8} rx={1.5} stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
      <rect x={21} y={4} width={8} height={8} rx={1.5} stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
      <rect x={21} y={20} width={8} height={8} rx={1.5} stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
      <path
        d="M11 16h5m0 0V8h5m-5 8v8h5"
        stroke="currentColor"
       
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default TreeStructure;
